import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DataTerm from '../../atoms/list/DataTerm';
import DataDefinition from '../../atoms/list/DataDefinition';
import DefinitionList from '../DefinitionList';
import { readableNumberParts } from '../../../helpers/Numbers';
import { useTranslation } from 'react-i18next';
import { readableDate } from '../../../helpers/Date';
const DossierDetails = ({ dossier }) => {
    const { t } = useTranslation();
    const items = [
        {
            label: 'Vorderingen',
            value: dossier.balance_status,
        },
        ...(dossier.remittances
            ? [
                {
                    label: 'Afdrachten',
                    value: readableNumberParts(dossier.remittances, 'EUR')
                        .long,
                },
            ]
            : []),
        {
            label: t('dossier.start_date'),
            value: readableDate(dossier.opened_at),
        },
        { label: 'Kenmerk', value: dossier.reference },
        {
            label: t('debtor'),
            value: dossier.debtor_name,
        },
    ];
    if (dossier.step) {
        items.push({
            label: t('dossier.step'),
            value: dossier.step,
        });
    }
    if (dossier.closed_at) {
        items.push({
            label: 'Sluitdatum',
            value: readableDate(dossier.closed_at),
        }, {
            label: 'Sluitreden',
            value: dossier.closing_reason,
        });
    }
    if (dossier.gas_ean) {
        items.push({
            label: 'Gasmeter',
            value: dossier.gas_ean.toString(),
        });
    }
    if (dossier.electricity_ean) {
        items.push({
            label: 'Elektriciteitsmeter',
            value: dossier.electricity_ean.toString(),
        });
    }
    if (dossier.clearance_date) {
        items.push({
            label: 'Datum ontruiming',
            value: readableDate(dossier.clearance_date),
        });
    }
    return (_jsx(_Fragment, { children: items.map(item => {
            return (_jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: item.label }), _jsx(DataDefinition, { children: item.value })] }, item.label));
        }) }));
};
export default DossierDetails;
